export * from './assignments.model';
export { AssignmentsService } from './assignments.service';
export { AssignmentsPipe } from './assignments.pipe';
